import React, { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { getAdvisers } from "../Store/adviser/actions";
import { capitalize } from "../Utils/validators";
import { decryptEstandar } from "../Utils/CryptographyUtils";

export default function SelectAdviser({ params, setParams, selectedOption, setSelectedOption }) {
  const dispatch = useDispatch();
  const dataStore = useSelector((state) => state.adviser.listAdvisers);
  const idClient = useSelector((state) =>
    decryptEstandar(state.login.idClient)
  );

  useEffect( () => {
    if (dataStore.length === 0) {
      const fetchData = async function () {
        getAdvisers(dispatch);
      };
      fetchData();
    }
    if (dataStore.length > 0) {
      dataStore.map((item) => {
        if (decryptEstandar(item.email) === idClient) {
          const label = capitalize(
            `${decryptEstandar(item.name)} ${decryptEstandar(
              item.lastName
            )}`.toLowerCase()
          );
          setSelectedOption({
            label,
            value: idClient,
          });
        }
      });
    }
    if (params.asesor !== null) {
      dataStore.map((item) => {
        if (decryptEstandar(item.email) === params.asesor) {
          const label = capitalize(
            `${decryptEstandar(item.name)} ${decryptEstandar(
              item.lastName
            )}`.toLowerCase()
          );
          setSelectedOption({
            label,
            value: params.asesor,
          });
        }
      });
    }
  }, [params.asesor, dataStore]);
  const getOptions = () => {
    if (dataStore.length > 0) {
      const options = dataStore.map((item) => {
        const label = capitalize(
          `${decryptEstandar(item.name)} ${decryptEstandar(
            item.lastName
          )}`.toLowerCase()
        );
        return {
          label,
          value: decryptEstandar(item.email),
        };
      });
      return options;
    }
    return [];
  };
  const handleChange = (itemSelect, actionMeta) => {
    setSelectedOption({
      label: itemSelect.label,
      value: itemSelect.value,
    });
    const emailAdviser = itemSelect ? itemSelect.value : null;
    setParams({
      ...params,
      emailAdviser,
    });
  };
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      // borderRadius: "20px",
      background: "#fff;",
      marginTop: "5px",
      // padding: "16px 24px"
    }),
    input: (provided, state) => ({
      ...provided,
      height: "100%",
      padding: "0.4rem 0",
      color: "#7981B2",
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      color: "#7981B2",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? "#EDEFFC !important" : "#fff !important",
      color: state.isFocused ? "#141938" : "#7981B2",
      // borderRadius: "20px",
      padding: "16px 24px",
      cursor: "pointer",
    }),
    control: (provided, state) => ({
      ...provided,
      borderRadius: "8px",
      border: "1px solid #A9AFD9",
      boxShadow: "none",
      cursor: "pointer",
      padding: "0",
      margin: "0",
      height: "56px",
      outline: "none", // width: "150px"
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Lato",
      color: "#7981B2",
    }),
    valueContainer: (provided, state) => ({
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      alignContent: "center",
      padding: "0 16px",
      height: "56px",
      outline: "none",
    }),
  };
  return (
    <div className="selectAdviser">
      <div className="content">
        {/* <div className="label">Asesor</div> */}
        <div className="select">
          <Fragment>
            {/* <select
              className="basic-single"
              classNamePrefix="select"
              name="adviser"
              isSearchable={true}
              isClearable={true}
              onChange={handleChange}
              placeholder="Usuario actual"
            >
              {getOptions().map((item, i) => (
                <option key={i} value={item}>
                  {item.label}
                </option>
              ))}
            </select> */}
            <Select
              className="basic-single"
              //defaultValue={getOptions().find((obj) => obj.value === idClient)}
              value={selectedOption}
              defaultValue={selectedOption}
              classNamePrefix="select"
              name="adviser"
              isSearchable={true}
              isClearable={false}
              options={getOptions()}
              onChange={handleChange}
              styles={customStyles}
              placeholder="Asesor"
            />
          </Fragment>
        </div>
      </div>
    </div>
  );
}
